"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const cardutil_1 = require("utils/cardutil");
const Query_1 = __importDefault(require("utils/Query"));
const Sort_1 = require("utils/Sort");
const FilterContext_1 = __importDefault(require("../contexts/FilterContext"));
const Banner_1 = __importDefault(require("./Banner"));
const Controls_1 = __importDefault(require("./base/Controls"));
const Layout_1 = require("./base/Layout");
const Link_1 = __importDefault(require("./base/Link"));
const Pagination_1 = __importDefault(require("./base/Pagination"));
const ResponsiveDiv_1 = __importDefault(require("./base/ResponsiveDiv"));
const Select_1 = __importDefault(require("./base/Select"));
const Spinner_1 = __importDefault(require("./base/Spinner"));
const Table_1 = __importDefault(require("./base/Table"));
const Text_1 = __importDefault(require("./base/Text"));
const DynamicFlash_1 = __importDefault(require("./DynamicFlash"));
const FilterCollapse_1 = __importDefault(require("./FilterCollapse"));
const WithAutocard_1 = __importDefault(require("./WithAutocard"));
const AutocardA = (0, WithAutocard_1.default)(Link_1.default);
const TopCardsTable = () => {
    const { filterInput } = (0, react_1.useContext)(FilterContext_1.default);
    const [cards, setCards] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [page, setPage] = (0, react_1.useState)(parseInt(Query_1.default.get('p', '0'), 0));
    const [count, setCount] = (0, react_1.useState)(Query_1.default.get('m', ''));
    const [sort, setSort] = (0, react_1.useState)(Query_1.default.get('s', 'Elo'));
    const [direction, setDirection] = (0, react_1.useState)(Query_1.default.get('d', 'descending'));
    const fetchData = (0, react_1.useCallback)(async () => {
        const params = new URLSearchParams([
            ['p', page.toString()],
            ['f', filterInput || ''],
            ['s', sort],
            ['d', direction],
        ]);
        const response = await fetch(`/tool/api/topcards/?${params.toString()}`);
        if (!response.ok) {
            console.error(response);
        }
        Query_1.default.set('f', filterInput || '');
        Query_1.default.set('p', page.toString());
        Query_1.default.set('s', sort);
        Query_1.default.set('d', direction);
        const json = await response.json();
        setCards(json.data);
        setCount(json.numResults.toString());
        setLoading(false);
    }, [page, filterInput, sort, direction]);
    (0, react_1.useEffect)(() => {
        fetchData();
    }, [page, direction, sort, filterInput]);
    const updatePage = (index) => {
        setLoading(true);
        setPage(index);
    };
    const updateSort = (index) => {
        setLoading(true);
        setSort(index);
    };
    const updateDirection = (index) => {
        setLoading(true);
        setDirection(index);
    };
    (0, react_1.useEffect)(() => {
        setLoading(true);
        setPage(0);
    }, [filterInput]);
    const headers = ['Name', 'Elo', 'Total Picks', 'Cube Count'];
    const rows = cards.map((card) => ({
        Name: (react_1.default.createElement(AutocardA, { href: `/tool/card/${card.scryfall_id}`, card: (0, cardutil_1.detailsToCard)(card) }, card.name)),
        Elo: card.elo === null ? '' : (0, cardutil_1.cardElo)((0, cardutil_1.detailsToCard)(card)).toFixed(0),
        'Total Picks': card.pickCount === null ? '' : card.pickCount,
        'Cube Count': card.cubeCount === null ? '' : card.cubeCount,
    }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Controls_1.default, { className: "p-2" },
            react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "2" },
                react_1.default.createElement(Banner_1.default, null),
                react_1.default.createElement(Layout_1.Flexbox, { direction: "row", justify: "between" },
                    react_1.default.createElement(Text_1.default, { xl: true, semibold: true }, "Search cards"),
                    react_1.default.createElement(ResponsiveDiv_1.default, { sm: true },
                        react_1.default.createElement(Layout_1.Flexbox, { direction: "row", gap: "4" },
                            react_1.default.createElement(Link_1.default, { href: "/tool/topcards" }, "View Top cards"),
                            react_1.default.createElement(Link_1.default, { href: "/tool/searchcards" }, "Search Cards")))),
                react_1.default.createElement(FilterCollapse_1.default, { isOpen: true, buttonLabel: "Search" }),
                react_1.default.createElement(Layout_1.Row, null,
                    react_1.default.createElement(Layout_1.Col, { xs: 12, sm: 6 },
                        react_1.default.createElement(Select_1.default, { label: "Sort", value: sort, setValue: (value) => updateSort(value), options: Sort_1.ORDERED_SORTS.map((s) => ({ value: s, label: s })) })),
                    react_1.default.createElement(Layout_1.Col, { xs: 12, sm: 6 },
                        react_1.default.createElement(Select_1.default, { label: "Direction", value: direction, setValue: (value) => updateDirection(value), options: [
                                { value: 'ascending', label: 'Ascending' },
                                { value: 'descending', label: 'Descending' },
                            ] }))))),
        react_1.default.createElement(DynamicFlash_1.default, null),
        (cards && cards.length) > 0 ? (react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "2", className: "my-2" },
            react_1.default.createElement(Layout_1.Flexbox, { direction: "row", justify: "between", wrap: "wrap", alignItems: "center" },
                react_1.default.createElement(Text_1.default, { lg: true, semibold: true, className: "whitespace-nowrap" },
                    react_1.default.createElement(ResponsiveDiv_1.default, { baseVisible: true, sm: true }, `${count} results`),
                    react_1.default.createElement(ResponsiveDiv_1.default, { md: true }, `Found ${count} results for the query: ${filterInput}`)),
                react_1.default.createElement(Pagination_1.default, { count: Math.ceil(parseInt(count, 10) / 96), active: page, onClick: (i) => updatePage(i) })),
            loading && (react_1.default.createElement("div", { className: "centered m-4" },
                react_1.default.createElement(Spinner_1.default, { xl: true }))),
            !loading && react_1.default.createElement(Table_1.default, { headers: headers, rows: rows }),
            react_1.default.createElement(Layout_1.Flexbox, { direction: "row", justify: "end" },
                react_1.default.createElement(Pagination_1.default, { count: Math.ceil(parseInt(count, 10) / 96), active: page, onClick: (i) => updatePage(i) })))) : (react_1.default.createElement(Text_1.default, { lg: true, semibold: true, className: "mt-2" }, "No cards found"))));
};
exports.default = TopCardsTable;
